<template>
    <section>
      <div v-html="mes">

      </div>
    </section>
</template>

<script>
    export default {
        name: "MessageView",
        props:{
          mes:null
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/message/MessageView.vue